export default __webpack_public_path__ + "static/contest-sweep-image-e6da40723823280a14a5215d2363d1ea.png";